import React from 'react';
import CreateWeekChallenge from './CreateWeekChallenge';
import Challenges from './Challenges';
import RankingByRegion from './RankingByRegion';
import RankingByParticipant from './RankingByParticipant';
import ChallengeResult from './ChallengeResult';
import ChallengeTab from './ChallengeTab';
import { ViewChallenge } from './ChallengeResult/ViewChallenge';
import ViewParticipantResult from './ChallengeResult/ViewParticipantResult';
import { DashboardContent } from '@/layouts/dashboard';

export function WeekChallenge(props) {
  const { selectedTab, uri } = props;

  const breadcrumbs = {
    title: 'Aprendizado Dinâmico',
    nav: [
      {
        route: uri,
        name: 'Desafio da Semana',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <ChallengeTab selectedTab={selectedTab} />

      {selectedTab === 'desafios' && <Challenges />}
      {selectedTab === 'ranking-por-regiao' && <RankingByRegion />}
      {selectedTab === 'ranking-por-participante' && <RankingByParticipant />}
      {selectedTab === 'resultados' && <ChallengeResult />}
    </DashboardContent>
  );
}

export { WeekChallenge as default, CreateWeekChallenge, ViewChallenge, ViewParticipantResult };
